import { isEqual } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaeDataGrid from "../common_widgets/data-grid";
import MdaeSwitch from "../common_widgets/switch";
import MdaeTextBox from "../common_widgets/text-box";
import $ from "jquery";
import {
  SET_FILTERED_MY_TASK_LIST,
  SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
} from "./reducers/user-task-card-view-reducer";
import MdaeSelectBox from "../common_widgets/select-box/component";
import MdaeCheckBox from "../common_widgets/check-box/component";
import { loadGridState, saveGridSetting } from "../common_widgets/data-grid/component";
export interface IUserTaskCardViewSearchBar {
  myTaskWidgetId: string;
  myTaskList: Array<any>;
  groupByPropertyName?: any;
  isFromMyTaskDashboardWidget?: boolean;
  isFromMyTaskPage?: boolean;
  isGroupByApplied?: boolean;
  isFromMyAuditView?: boolean;
}
const UserTaskCardViewSearchBar: React.FC<IUserTaskCardViewSearchBar> = (props) => {
  const dispatch = useDispatch();
  const userTaskFilterConfigKey = {
    storageKey: "user-task-filter-config",
  };

  let myTaskWidgetConfig = useSelector(
    (state) => state["myTaskReducer"].myTaskWidgetConfig,
    isEqual
  );
  myTaskWidgetConfig = myTaskWidgetConfig[props.myTaskWidgetId];

  const filteredMyTaskList = useSelector(
    state => state["myTaskReducer"].filteredMyTaskList?.[props.myTaskWidgetId]
  );

  React.useEffect(() => {
    loadGridState(dispatch, userTaskFilterConfigKey).then((savedState) => {
      if (savedState?.filterText) {
        dispatch({
          type: SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
          data: {
            filterText: savedState.filterText,
            myTaskWidgetId: props.myTaskWidgetId,
          },
        });

        filterMyTaskList(savedState.filterText);
      }
    });
  }, []);

  const getFlatTaskList = () => {
    const originalList = props.myTaskList;

    if (
      myTaskWidgetConfig?.isGroupByApplied &&
      originalList &&
      typeof originalList === "object" &&
      !Array.isArray(originalList)
    ) {
      // Grouped: flatten all arrays in the object
      return Object.values(originalList).flat();
    }

    // Not grouped: already a flat array

    return originalList || [];
  };


  const filterMyTaskList = (filterText) => {
    dispatch({
      type: SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
      data: {
        filterText: filterText,
        myTaskWidgetId: props.myTaskWidgetId,
      },
    });

    saveGridSetting({ filterText }, userTaskFilterConfigKey, true);

    const flatList = getFlatTaskList();
    let filtered = flatList;
    if (filterText) {
      const lower = filterText.toLowerCase();
      filtered = flatList.filter(item =>
        Object.values(item).some(
          v => v && v.toString().toLowerCase().includes(lower)
        )
      );
    }
    dispatch({
      type: SET_FILTERED_MY_TASK_LIST,
      data: {
        myTaskWidgetId: props.myTaskWidgetId,
        filteredMyTaskList: filtered,
      },
    });
  };

  const handleClearFilters = () => {
    dispatch({
      type: SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
      data: {
        filterText: '',
        myTaskWidgetId: props.myTaskWidgetId,
      },
    });

    saveGridSetting({ filterText: '' }, userTaskFilterConfigKey, true);
    filterMyTaskList("");
  };

  return (
    <div className={"user-task-searchbar-container"}>
      <MdaeDataGrid
        id={""}
        visible={false}
        dataSource={
          myTaskWidgetConfig?.filterText
            ? (filteredMyTaskList || [])
            : getFlatTaskList()
        }
        searchPanel={{
          visible: true,
          text: myTaskWidgetConfig?.filterText,
        }}
        mdaeColumns={[
          { dataField: "refTaskName" },
          { dataField: "status" },
          { dataField: "taskCategoryName" },
          { dataField: "taskCategoryTypeDisplayName" },
          { dataField: "refTaskDescription" },
          { dataField: "schedulingNotes" },
          { dataField: "auditorNotes" },
          { dataField: "managerNotes" },
        ]}
      ></MdaeDataGrid>
      <div className="user-task-searchbar-left-section">
        <div className={"user-task-search-box-container"}>
          <MdaeTextBox
            id={""}
            placeholder={"Search..."}
            value={myTaskWidgetConfig?.filterText || ''}
            onValueChanged={(e) => {
              filterMyTaskList(e.value);
            }}
            onKeyUp={(e) => {
              filterMyTaskList($(e.event.target).val());
            }}
          ></MdaeTextBox>
          <div
            className={
              "dx-icon dx-icon-search user-task-card-datagrid-search-icon application-section-primary-background-color"
            }
          ></div>
        </div>

        <div
          id="clearFilterButton"
          onClick={handleClearFilters}
          className={`user-task-clear-filter-container ${myTaskWidgetConfig?.filterText ? "application-section-primary-color" : ""}`}
          title="Clear Filter"
          aria-label="Clear Filter"
          role="button"
        >
          <span className="fa-stack" style={{ fontSize: "11px" }}>
            <i className="fa fa-filter fa-stack-2x "></i>
            <i className="fa fa-times fa-stack fa-times-style " style={{ position: "absolute", left: "65%" }}></i>
          </span>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center" }}>
        {!(props.isFromMyTaskDashboardWidget || props.isFromMyTaskPage) && (
          <div className={"user-task-show-canceled-checkbox-container"}>
            <MdaeCheckBox
              id="chkUserTaskCanceledSatusCheckBox"
              text="Include Canceled Tasks"
              onValueChanged={(e) => {
                dispatch({
                  type: SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
                  data: {
                    isShowCanceledStatusTypeTaskList: e.value,
                    myTaskWidgetId: props.myTaskWidgetId,
                  },
                });
              }}
            />
          </div>
        )}

        <div className={"user-task-group-by-toggle-parent-container"}>
          <div className={"user-task-group-by-toggle-container"}>
            <div className={"user-task-group-by-toggle-text"}>Group Tasks:</div>
            <MdaeSwitch
              value={myTaskWidgetConfig?.isGroupByApplied}
              onValueChanged={(e) => {
                if (e.event)
                  dispatch({
                    type: SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
                    data: {
                      myTaskWidgetId: props.myTaskWidgetId,
                      isGroupByApplied: e.value,
                      groupByPropertyName: "myTaskGroupByAuditName",
                    },
                  });
              }}
            ></MdaeSwitch>
          </div>
          {myTaskWidgetConfig?.isGroupByApplied &&
            !props.isFromMyTaskDashboardWidget &&
            !props.isFromMyAuditView && (
              <div className={"user-task-group-by-property-selector"}>
                <MdaeSelectBox
                  id={""}
                  mdaeDropDownBoxTitle={"Group By"}
                  displayExpr={"displayName"}
                  valueExpr={"value"}
                  value={props.groupByPropertyName}
                  dataSource={[
                    { displayName: "Audit", value: "myTaskGroupByAuditName" },
                    {
                      displayName: "Entity",
                      value: "myTaskGroupByOrgEntityName",
                    },
                    {
                      displayName: "Maintenance",
                      value: "myTaskGroupByMaintenanceEntityName",
                    },
                  ]}
                  onValueChanged={(e) => {
                    dispatch({
                      type: SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
                      data: {
                        myTaskWidgetId: props.myTaskWidgetId,
                        groupByPropertyName: e.value,
                      },
                    });
                  }}
                ></MdaeSelectBox>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default UserTaskCardViewSearchBar;
